import axios from 'axios'
import lodash from 'lodash'
import router from '../../../router'
import moment from 'moment'

const LOGIN = 'LOGIN'
const LOGOUT = 'LOGOUT'
const SETACTIVE = 'SETACTIVE'
const SETIDLE = 'SETIDLE'
const UPDATE_USER = 'UPDATE_USER'
const UPDATE_WAIT_FOR_FIRST_LOGIN = 'UPDATE_WAIT_FOR_FIRST_LOGIN'
const UPDATE_SHOW_2FA_AFTER_LOGIN = 'UPDATE_SHOW_2FA_AFTER_LOGIN'
const LOCAL_STORE = process.env.VUE_APP_BASE_NAME + '-frontend'

let millisecondsBeginnIdle = 0
let millisecondsAtRefreshtime = 0
let repeatTime = 840000
let intervalCounterTimer = null

const state = {
  isLoggedIn: false,
  user: null,
  idleStatus: 'idle',
  showLoginPopup: false,
  show2faAfterLogin: false,
  remainingTime: 0,
  timeCounter: '0'       //gibt die ablaufende zeit an also z.b: 12min:44sec
};

const mutations = {
  [LOGIN] (state, user) {
    state.isLoggedIn = true
    state.user = user
    state.showLoginPopup = false
  },
  [LOGOUT] (state) {
    state.isLoggedIn = false
    state.user = null
    state.showLoginPopup = false
  },
  [SETACTIVE] (state) {
    millisecondsBeginnIdle = 0
    state.idleStatus = 'active'
  },
  [SETIDLE] (state) {
    millisecondsBeginnIdle = (new Date()).getTime()
    state.idleStatus = 'idle'
  },
  [UPDATE_USER] (state, user) {
    if (state.user && state.user.user && Object.keys(user).length > 1) {
      state.user.user = user
    }
    if (typeof user.is_active_2fa !== 'undefined') {
      state.user.is_active_2fa = user.is_active_2fa
    }
  },
  [UPDATE_WAIT_FOR_FIRST_LOGIN] (state) {
    if (state.user && state.user.user) {
      state.user.user.waitForFirstLogin = false
    }
  },
  [UPDATE_SHOW_2FA_AFTER_LOGIN] (state, value) {
    state.show2faAfterLogin = value
  }
};

/**
 * berechnet die Zeit vom abholen eines Tokens bis zum Refresh für ein neues token
 *
 * (darauf wird in "function checkRefresh()" geprüft ob man innerhalb dieser zeit noch aktiv war und ein neues
 * token bekommen darf oder ob man zu lange inaktiv war und sich neu anmelden muss)
 *
 * **/
function calculateRepeatTime (expireDate) {
  let begin = moment(new Date())
  let end = moment(expireDate)
  let duration = moment.duration(end.diff(begin))
  return duration.asMilliseconds()
}

/**
 * wird zum login oder initauth aufgerufen und startet ein intervall "intervalCounterTimer" das sich dauerhaft alle 1000ms wiederholt
 * jede sekunde wird dann gerpüft ob man noch innerhalb der repeattime ist (normal 15min) oder ob der sessionkey noch da ist
 * falls nein kommt sofort das login popup
 *
 * wenn man 30sekunde vor dem ablaufen ist und sonst alles stimmt wird intervall "intervalCounterTimer" gekillt und checkinterval() aufgerufen
 * **/
function repeatCounter () {
  clearInterval(intervalCounterTimer)

  /**
   * setIntervale erzeugt ein ewig laufenden Intervall ähnlich einer while schleife
   * **/
  intervalCounterTimer = setInterval(() => {

    let remaining = calculateRepeatTime(state.user.tokenExpire)
    // state.timeCounter = moment(new Date()).format('HH:mm') + ' Uhr | ' + moment.utc(remaining).format('mm:ss') + ' min:sek'
    state.timeCounter = {
      now: moment(new Date()).format('HH:mm'),
      later: moment(state.user.tokenExpire).format('HH:mm'),
      timer: {
        min: moment.utc(remaining).format('mm'),
        sec: moment.utc(remaining).format('ss')
      }
    }
    const user = JSON.parse(window.sessionStorage.getItem(LOCAL_STORE))

    if (remaining < 30000 && remaining > 0) {  //30000ms als Puffer vor expire
      clearInterval(intervalCounterTimer)
      checkRefresh()
    } else if (!user || remaining <= 0) {
      clearInterval(intervalCounterTimer)
      state.showLoginPopup = true
    }
  }, 1000)
}

/**
 *
 * prüft ob man angemeldet ist und ob man noch refreshen darf, wenn nein dann sofort zum lopgin popup
 * wenn ja dann axios aufruf zum refresh, neue repeatTime berechnen und repeatCounter() wieder aufrufen
 * damit intervall wieder jede sekunde läuft
 *
 * **/
function checkRefresh () {
  millisecondsAtRefreshtime = (new Date()).getTime()

  if (state.user) {
    if (millisecondsAtRefreshtime - millisecondsBeginnIdle < repeatTime || millisecondsBeginnIdle === 0) {
      axios.get(state.user.refreshRoute)
        .then(result => {
          // let tempUser = state.user
          state.user.token = result.data.token
          state.user.tokenExpire = result.data.token_expire
          window.sessionStorage.setItem(LOCAL_STORE, JSON.stringify(state.user))

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + result.data.token

          repeatTime = calculateRepeatTime(state.user.tokenExpire)

          repeatCounter()

        })
        .catch(() => {
          state.showLoginPopup = true
        })
    } else {
      state.showLoginPopup = true
    }
  }
}

function logout () {
  if (state.user) {
    axios.get(state.user.logoutRoute)
      .then(result => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + result.data.token
      })
      .catch(() => {})
  }

  // remove user from local session storage
  window.sessionStorage.removeItem(LOCAL_STORE)

  // Set header
  axios.defaults.headers.common['Authorization'] = 'null'

  clearInterval(intervalCounterTimer);

  if (!window.location.pathname.startsWith('/auth/')) {
    router.push('/auth/login')
  }
}

function updateUserInSessionStore (user) {
  // update user in session store
  let storage = JSON.parse(window.sessionStorage.getItem(LOCAL_STORE))
  storage.user = user
  window.sessionStorage.setItem(LOCAL_STORE, JSON.stringify(storage))
}

const actions = {
  /**
   * setzt den Idle status auf true, also wenn man 5sec. lang nix mehr gemacht hat
   */
  setIdle ({ commit }) {
    commit(SETIDLE)
  },
  /**
   * setzt den active status auf true, also wenn man nach einer idle phase wieder etwas macht in der app
   */
  setActive ({ commit }) {
    commit(SETACTIVE)
  },
  /**
   * initAuth wird in der index.js des auth plugins im created aufgerufen und damit einmal zur Erstelllung der App
   * bei strg + r oder RefreshButton des Browser wird es somit ebenfalls aufgerufen
   */
  initAuth ({ commit }) {
    /**
     * hole ganzes user objekt aus dem Session-Store
     */
    const user = JSON.parse(window.sessionStorage.getItem(LOCAL_STORE))

    /**
     * falls user und token noch existieren kann geprüft werden, ob sie noch gültig sind,
     * falls ja wird man automatisch angemeldet, falls nein zum Login geleitet
     */
    if (user) {
      /**
       * setze den token als header für die axios aufrufe
       */
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.token

      /**
       * falls es einen user und tokenExpire date gibt, dann berechne die repeatTime, diese entspricht der Laufzeit des Repeat Zyklus
       * anschließend wird der Counter aufgerufen, der die Zeit runterzählt
       */
      if (repeatTime > 0 && !intervalCounterTimer && user.tokenExpire) {
        repeatTime = calculateRepeatTime(user.tokenExpire)
        repeatCounter()
        commit(LOGIN, user)

      } else {
        logout()
        router.push('/auth/login')
        commit(LOGOUT)
      }
    } else {
      logout();
      commit(LOGOUT)
    }
  },
  login ({ commit }, obj) {
    let user = obj.data // gesamtes Userobjekt (token, acl, user, routes)
    let type = obj.type // login oder relogin

    if (user) {
      let policies = [];

      if (Object.prototype.hasOwnProperty.call(user.acl, 'perm') && Array.isArray(user.acl.perm)) {
        user.acl.perm.forEach((v) => {
          if (v && typeof v.obj === 'string') {
            policies.push({
              action: v.obj.replace('*', '.*')
            })
          }
        });
        user.policies = policies
      }

      /**
       * speichere ganzes user objekt (user, acl, routes, token) im lokalen session store
       * **/
      window.sessionStorage.setItem(LOCAL_STORE, JSON.stringify(user))

      /**
       * setze den token als header für die axios aufrufe
       */
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.token

      /**
       * falls es einen user und tokenExpire date gibt, dann berechne die repeatTime, diese entspricht der Laufzeit des Repeat Zyklus
       * anschließend wird der Counter aufgerufen der die Zeit runter zählt
       */
      if (user && user.tokenExpire) {
        repeatTime = calculateRepeatTime(user.tokenExpire)
        repeatCounter()
      }

      /**
       * ändere noch die notwendigen Stati über die Mutation Login Siehe Zeile 24
       * state.isLoggedIn = true
       * state.user = user
       * state.showLoginPopup = false
       */
      commit(LOGIN, user);

      /**
       * abschließend rufe die Standard-Route auf, allerdings nur, wenn es sich um einen Initial-Login handelt
       * und nicht beim Relogin über das Popup
       */
      if (type === 'login') {
        if (user.user.is_system) {
          router.push('/account')
        } else {
          router.push('/')
          // if (user && user.user && user.user.settings && user.user.settings.tabs) {
          //   const tabs = user.user.settings.tabs
          //   const currentTab = tabs.tabs[tabs.activeTab]
          //   router.push(currentTab.to ? currentTab.to : { name: currentTab.routeName, params: currentTab.routeParams })
          // } else {
          //   router.push('/')
          // }
        }
      }
    }
  },
  logout ({ commit }) {
    logout()

    // Change state
    commit(LOGOUT)
  },
  updateUser ({ commit }, user) {
    // Change state
    commit(UPDATE_USER, user)
    updateUserInSessionStore(user)
  },
  updateWaitForFirstLogin ({ commit, state }, data) {
    commit(UPDATE_WAIT_FOR_FIRST_LOGIN, data)

    if (state && state.user && state.user.user) {
      updateUserInSessionStore(state.user.user)
    }
  },
  updateShow2faAfterLogin ({ commit }, data) {
    commit(UPDATE_SHOW_2FA_AFTER_LOGIN, data)
  }
};

const getters = {
  idleStatus: state => {
    return state.idleStatus
  },
  repeatCounterTime: state => {
    return state.timeCounter
  },
  showLoginPopup: state => {
    return state.showLoginPopup
  },
  show2faAfterLogin: state => {
    return state.show2faAfterLogin
  },
  isLoggedIn: state => {
    return state.isLoggedIn
  },
  getAuthUserPolicies: state => {
    return state.user.acl.perm || []
  },
  getAuthUserData: state => {
    return state.user
  },
  getAuthUserName: state => {
    let userstring = ''
    if (state.user && state.user.user && state.user.user.first_name) {
      userstring += state.user.user.first_name
    }
    if (state.user && state.user.user && state.user.user.last_name) {
      userstring = userstring + ' ' + state.user.user.last_name
    }
    if (state.user && !state.user.user.first_name && !state.user.user.last_name && state.user.user.email) {
      userstring += state.user.user.email
    }
    return userstring
  },
  getAuthUserTitle: state => {
    if (state.user && state.user.user) {
      return state.user.user.title
    }
  },
  userIsAdmin: state => {
    const userData = state.user || { acl: {} }
    return lodash.includes(userData.acl.roles, 'root')
  },
  userIsSystemadmin: state => {
    const userData = state.user || { acl: {} };
    return lodash.includes(userData.acl.roles, 'systemadmin') && !lodash.includes(userData.acl.roles, 'root')
  },
  userIsPhysicianOrEmployee: state => {
    const userData = state.user || { acl: {} }
    return (lodash.includes(userData.acl.roles, 'physician') || lodash.includes(userData.acl.roles, 'employee')) && !lodash.includes(userData.acl.roles, 'root')
  },
  userIsPhysician: state => {
    const userData = state.user || { acl: {} }
    return lodash.includes(userData.acl.roles, 'physician') && !lodash.includes(userData.acl.roles, 'root')
  }
};
export default {
  state,
  mutations,
  actions,
  getters
}
